import { render, staticRenderFns } from "./ReservationInfos.vue?vue&type=template&id=139f2e2a&scoped=true"
import script from "./ReservationInfos.vue?vue&type=script&lang=js"
export * from "./ReservationInfos.vue?vue&type=script&lang=js"
import style0 from "./ReservationInfos.vue?vue&type=style&index=0&id=139f2e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f2e2a",
  null
  
)

export default component.exports